module.exports = __webpack_public_path__ + "static/media/genuine-background-MS.7e546774.png";